/* This abstracts the Quill editor and ReactQuill wrapper.
   <ReactQuill/> props at https://github.com/zenoamaro/react-quill?tab=readme-ov-file#props
*/

// @ts-ignore
import ReactQuill, {Quill} from "react-quill";
import "react-quill/dist/quill.snow.css";
Quill.debug("error");
export {ReactQuill, Quill};